// Activities Store
import notificationPlugin from '@/plugins/notification'

const state = {
  activities: [],
  pagination: {},
  unread_activities: 0,
  pending: false,
}

const getters = {}

const actions = {
  getActivities({ commit }, page = 1) {
    return new Promise(resolve => {
      commit('SET_PENDING')
      this.api.items
      .getItems('activities', { page })
      .then(({ data }) => {
        commit('SET_ACTIVITIES', data)
        commit('SET_PENDING')
        resolve()
      })
    })
  },
  getCountUnreadActivities({ commit }) {
    return new Promise(resolve => {
      commit('SET_PENDING')
      this.api.items
      .getItems('activities.unread_activities')
      .then(({ data }) => {
        commit('SET_UNREAD_ACTIVITIES', data)
        commit('SET_PENDING')
        resolve()
      })
    })
  },
  notification() {
    return notificationPlugin(this._actions['activities/handleNotification'][0])
  },
  handleNotification({ dispatch }, data) {
    if (!data.old) {
      dispatch('getCountUnreadActivities')
    }
  },
}

const mutations = {
  SET_PENDING: state => {
    state.pending = !state.pending
  },
  SET_ACTIVITIES: (state, { results, pagination }) => {
    state.activities = results
    state.pagination = pagination
  },
  SET_UNREAD_ACTIVITIES: (state, { results }) => {
    state.unread_activities = results
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
